// Mirrors ezbuild_back's apps/communication/sms_segments.py, so the editor and the send agree on parts.
const GSM_BASIC =
  "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?" +
  "¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà"
const GSM_EXTENDED = "^{}\\[~]|€\f"

export const MAX_SEGMENTS = 10

export interface SegmentCount {
  encoding: "GSM-7" | "UCS-2"
  characters: number
  segments: number
}

export const countSegments = (text: string): SegmentCount => {
  const characters = Array.from(text ?? "")
  const isGsm = characters.every(
    (ch) => GSM_BASIC.includes(ch) || GSM_EXTENDED.includes(ch)
  )
  const units = isGsm
    ? characters.reduce(
        (sum, ch) => sum + (GSM_EXTENDED.includes(ch) ? 2 : 1),
        0
      )
    : characters.reduce(
        (sum, ch) => sum + ((ch.codePointAt(0) ?? 0) > 0xffff ? 2 : 1),
        0
      )
  const [single, part] = isGsm ? [160, 153] : [70, 67]
  const segments =
    units === 0 ? 0 : units <= single ? 1 : Math.ceil(units / part)
  return { encoding: isGsm ? "GSM-7" : "UCS-2", characters: units, segments }
}
